module.exports = __webpack_public_path__ + "img/main.9a02f133.png";